// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"YoutubeEmbed_YoutubeEmbed__P3IlB"};